import { useCallback } from 'react';
import { useTheme } from '@mui/material';

const useNpsScoreColor = () => {
  const theme = useTheme();

  return useCallback(
    (score: number, neutralScore = 0) => {
      if (score > neutralScore) return theme.colors.tertiary[700];
      if (score < neutralScore) return theme.colors.error[600];
      return theme.colors.neutral[500];
    },
    [theme],
  );
};

export default useNpsScoreColor;
